const createNotificationsSlice = (set, get) => ({
  notifications: [],
  notificationsCount: 0,
  hasMoreNotifications: false,
  isInitialNotificationsLoading: false,
  isFetchingNextNotificationsPage: false,
  notificationsPage: 1,
  fetchNextNotificationsPage: () => {},
  markNotificationsAsReadViaSocket: () => {},
  addNotifications: (newNotifications) => {
    const { notifications } = get();
    set({ notifications: [...notifications, ...newNotifications] });
  },
  upsertNotification: (newNotification) => {
    if (!newNotification || !newNotification.id) return;

    const { notifications } = get();
    const existingIndex = notifications.findIndex(notification => notification.id === newNotification.id);

    if (existingIndex >= 0) {
      const updatedNotifications = [...notifications];
      updatedNotifications[existingIndex] = newNotification;
      set({ notifications: updatedNotifications });
    } else {
      set({ notifications: [newNotification, ...notifications] });
    }
  },
  setNotificationsCount: (count) => set({ notificationsCount: count }),
  setHasMoreNotifications: (hasMore) => set({ hasMoreNotifications: hasMore }),
  setIsInitialNotificationsLoading: (isLoading) => set({ isInitialNotificationsLoading: isLoading }),
  setIsFetchingNextNotificationsPage: (isFetching) => set({ isFetchingNextNotificationsPage: isFetching }),
  setFetchNextNotificationsPage: (fetchNextNotificationsPage) => set({ fetchNextNotificationsPage }),
  setMarkNotificationsAsReadViaSocket: (fn) => set({ markNotificationsAsReadViaSocket: fn }),
  incrementNotificationsPage: () => {
    const { notificationsPage } = get();
    set({ notificationsPage: notificationsPage + 1 });
  },
  resetNotificationsState: () => set({
    notifications: [],
    notificationsCount: 0,
    hasMoreNotifications: false,
    isInitialNotificationsLoading: false,
    isFetchingNextNotificationsPage: false,
    notificationsPage: 0
  })
});

export default createNotificationsSlice;
